import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { handleFetchError } from 'src/Libs/api/utils'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { InstallationAddressFormValues } from '../types'

export const saveInstallationAddress = async (
  installationId: number | undefined,
  data: InstallationAddressFormValues,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null, AuthFetchError | Error>> => {
  try {
    if (!installationId) {
      return new ApiResult<null, AuthFetchError | Error>(null, true, new Error('No installationId provided'))
    }
    const response = await authFetch<void>({
      path: `installations/${installationId}/address`,
      method: 'PUT',
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      payload: data,
    })

    if (response.status === StatusCodes.NO_CONTENT) {
      return new ApiResult<null, AuthFetchError | Error>(null, false)
    }

    return new ApiResult<null, AuthFetchError | Error>(null, true)
  } catch (error) {
    return handleFetchError<null>(error)
  }
}
